import { useMemo } from 'react';
import { useLocalStorage } from 'react-use';

import { DocumentType } from '@/types/schema';

import {
  DocumentsTableContext,
  DocumentsTableContextValue,
} from './DocumentsTable.context';

interface DocumentsTableProviderProps {
  children: React.ReactNode;
  variant?: 'household-documents' | 'entity-documents';
}

export function DocumentsTableProvider({
  children,
  variant,
}: DocumentsTableProviderProps) {
  const [filterValue, setFilterValue] = useLocalStorage<
    Record<'documentType', DocumentType[]>
  >('documentsTableFilter', { documentType: [] });

  const contextValue = useMemo<DocumentsTableContextValue>(
    () => ({
      filterValue: filterValue ?? { documentType: [] },
      setFilterValue,
      variant,
    }),
    [filterValue, setFilterValue, variant]
  );

  return (
    <DocumentsTableContext.Provider value={contextValue}>
      {children}
    </DocumentsTableContext.Provider>
  );
}
